export default __webpack_public_path__ + "static/media/Move.43732551.svg";